import React from 'react';
import './styles.css';

const PreguntaCard = ({ pregunta, respuestaBD, respuesta, onChange }) => {
  const valorSeleccionado = respuesta ?? respuestaBD;

  return (
    <div className="pregunta-card">
      <div className="encuesta-nombre">{pregunta.texto}</div>
      <div className="encuesta-valores">
        <div className="encuesta-valor">1 = {pregunta.min_valor}</div>
        <div className="encuesta-valor">10 = {pregunta.max_valor}</div>
      </div>
      <div className="opciones">
        {Array.from({ length: 10 }, (_, i) => i + 1).map((valor) => (
          <button
            key={valor}
            className={`opcion ${valorSeleccionado === valor ? 'seleccionada' : ''}`}
            onClick={() => onChange(valor)}
          >
            {valor}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PreguntaCard;
